// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e72ba8a","239":"05d1037d","453":"926f0775","455":"0b3d2385"}[chunkId] + ".chunk.js";
};